import * as React from "react";

const SvgRoomService = ({ color, size }) => (
  <svg
    viewBox="0 0 32 32"
    width={`${28 * (size || 1)}px`}
    height={`${28 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.3}
      d="M16 12.773c-3.933 0-7.293 2.44-8.666 5.88h17.333c-1.373-3.44-4.733-5.88-8.666-5.88z"
      fill={color}
    />
    <path
      d="M2.666 22.667h26.667v2.667H2.666v-2.667zm15.787-12.28A2.675 2.675 0 0 0 16 6.667a2.674 2.674 0 0 0-2.454 3.72c-5.213 1.08-9.187 5.52-9.547 10.947h24c-.36-5.427-4.333-9.867-9.546-10.947zm-2.454 2.387c3.934 0 7.294 2.44 8.667 5.88H7.333c1.373-3.44 4.733-5.88 8.666-5.88z"
      fill={color}
    />
  </svg>
);

export default SvgRoomService;
